import { Grid } from '@react-three/drei'
import { useLayoutEffect, useRef } from 'react'
import type { Mesh, PlaneGeometry, ShaderMaterial } from 'three'

export interface PropsTerreno3D {
  /** Lado do terreno, metros. */
  ladoM?: number
  /** Grade de referência de 10 m / 100 m sobre o terreno — ajuda a ler distâncias. */
  comGrade?: boolean
  aoClicar?: (ponto: readonly [number, number]) => void
}

/**
 * Chão da cena: campo gramado plano e, opcionalmente, a grade métrica.
 *
 * O clique devolve o ponto (x, z) no chão; é por aqui que as oficinas
 * posicionam o que o aluno arrasta (caminhão receptor, biruta).
 */
export function Terreno3D({
  ladoM = 3000,
  comGrade = true,
  aoClicar,
}: PropsTerreno3D) {
  const grade = useRef<Mesh<PlaneGeometry, ShaderMaterial>>(null)
  useLayoutEffect(() => {
    const material = grade.current?.material
    if (!material) return
    // A grade não escreve profundidade; fica à frente do terreno e atrás
    // do asfalto (-2) e da sinalização (-3), sem depender de milímetros em Y.
    material.depthWrite = false
    material.polygonOffset = true
    material.polygonOffsetFactor = -0.5
    material.polygonOffsetUnits = -0.5
  }, [comGrade])

  return (
    <group>
      <mesh
        rotation={[-Math.PI / 2, 0, 0]}
        receiveShadow
        onClick={
          aoClicar
            ? (evento) => {
                evento.stopPropagation()
                aoClicar([evento.point.x, evento.point.z])
              }
            : undefined
        }
      >
        <planeGeometry args={[ladoM, ladoM]} />
        <meshStandardMaterial color="#3d4a34" roughness={1} />
      </mesh>
      {comGrade && (
        <Grid
          ref={grade}
          raycast={() => null}
          position={[0, 0.002, 0]}
          args={[ladoM, ladoM]}
          cellSize={10}
          sectionSize={100}
          cellColor="#56644b"
          sectionColor="#7d8b6e"
          cellThickness={0.6}
          sectionThickness={1.1}
          fadeDistance={ladoM * 0.6}
          fadeStrength={1.5}
        />
      )}
    </group>
  )
}
